// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".my-section{color:var(--my-main-text-color);background-color:var(--my-main-bg-color)}.h-theme--hoshinoya .my-section{--my-main-text-color:#fff}.my-section:nth-child(2n){--my-main-bg-color:var(--theme-brand-secondary-background);--my-secondary-bg-color:var(--theme-brand-foundation-background)}.h-theme--hoshinoya .my-section:nth-child(2n){--my-main-text-color:#fff}", ""]);
// Exports
module.exports = exports;
